var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicroprocessador(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.8543 9.14648H9.14648V70.8543H70.8543V9.14648Z",
    fill: "#57A4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6223 28.502H31.627V51.4973H54.6223V28.502Z",
    fill: "#78B9EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8281 22.1367H63.5938V27.3711H68.8281V22.1367Z",
    fill: "#78B9EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8281 30.9375H63.5938V36.1719H68.8281V30.9375Z",
    fill: "#78B9EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4973 28.502H28.502V51.4973H51.4973V28.502Z",
    fill: "#FFB655"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8285 13.2539H70.8535V17.5247H78.8285V13.2539Z",
    fill: "#FFE477"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8285 23.0977H70.8535V27.3684H78.8285V23.0977Z",
    fill: "#FFE477"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8285 32.9414H70.8535V37.2122H78.8285V32.9414Z",
    fill: "#FFE477"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8285 42.7852H70.8535V47.0559H78.8285V42.7852Z",
    fill: "#FFE477"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8285 52.6289H70.8535V56.8997H78.8285V52.6289Z",
    fill: "#FFE477"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8285 62.4727H70.8535V66.7434H78.8285V62.4727Z",
    fill: "#FFE477"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14688 13.2539H1.17188V17.5247H9.14688V13.2539Z",
    fill: "#FFE477"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14688 23.0977H1.17188V27.3684H9.14688V23.0977Z",
    fill: "#FFE477"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14688 32.9414H1.17188V37.2122H9.14688V32.9414Z",
    fill: "#FFE477"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14688 42.7852H1.17188V47.0559H9.14688V42.7852Z",
    fill: "#FFE477"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14688 52.6289H1.17188V56.8997H9.14688V52.6289Z",
    fill: "#FFE477"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14688 62.4727H1.17188V66.7434H9.14688V62.4727Z",
    fill: "#FFE477"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7434 70.8535H62.4727V78.8285H66.7434V70.8535Z",
    fill: "#FFD422"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8997 70.8535H52.6289V78.8285H56.8997V70.8535Z",
    fill: "#FFD422"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0559 70.8535H42.7852V78.8285H47.0559V70.8535Z",
    fill: "#FFD422"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2122 70.8535H32.9414V78.8285H37.2122V70.8535Z",
    fill: "#FFD422"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3684 70.8535H23.0977V78.8285H27.3684V70.8535Z",
    fill: "#FFD422"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5247 70.8535H13.2539V78.8285H17.5247V70.8535Z",
    fill: "#FFD422"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7434 1.17188H62.4727V9.14688H66.7434V1.17188Z",
    fill: "#FFD422"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8997 1.17188H52.6289V9.14688H56.8997V1.17188Z",
    fill: "#FFD422"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0559 1.17188H42.7852V9.14688H47.0559V1.17188Z",
    fill: "#FFD422"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2122 1.17188H32.9414V9.14688H37.2122V1.17188Z",
    fill: "#FFD422"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3684 1.17188H23.0977V9.14688H27.3684V1.17188Z",
    fill: "#FFD422"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5247 1.17188H13.2539V9.14688H17.5247V1.17188Z",
    fill: "#FFD422"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7031 22.1367H60.4688V27.3711H65.7031V22.1367Z",
    fill: "#FF3F62"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7031 30.9375H60.4688V36.1719H65.7031V30.9375Z",
    fill: "#FF3F62"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8285 13.2539H70.8535V17.5247H78.8285V13.2539Z",
    fill: "#FFE477"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8285 23.0977H70.8535V27.3684H78.8285V23.0977Z",
    fill: "#FFE477"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8285 32.9414H70.8535V37.2122H78.8285V32.9414Z",
    fill: "#FFE477"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8285 42.7852H70.8535V47.0559H78.8285V42.7852Z",
    fill: "#FFE477"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8285 52.6289H70.8535V56.8997H78.8285V52.6289Z",
    fill: "#FFE477"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8285 62.4727H70.8535V66.7434H78.8285V62.4727Z",
    fill: "#FFE477"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7434 70.8535H62.4727V78.8285H66.7434V70.8535Z",
    fill: "#FFD422"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8997 70.8535H52.6289V78.8285H56.8997V70.8535Z",
    fill: "#FFD422"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0559 70.8535H42.7852V78.8285H47.0559V70.8535Z",
    fill: "#FFD422"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2122 70.8535H32.9414V78.8285H37.2122V70.8535Z",
    fill: "#FFD422"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3684 70.8535H23.0977V78.8285H27.3684V70.8535Z",
    fill: "#FFD422"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5247 70.8535H13.2539V78.8285H17.5247V70.8535Z",
    fill: "#FFD422"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7434 1.17188H62.4727V9.14688H66.7434V1.17188Z",
    fill: "#FFD422"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8997 1.17188H52.6289V9.14688H56.8997V1.17188Z",
    fill: "#FFD422"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0559 1.17188H42.7852V9.14688H47.0559V1.17188Z",
    fill: "#FFD422"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2122 1.17188H32.9414V9.14688H37.2122V1.17188Z",
    fill: "#FFD422"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3684 1.17188H23.0977V9.14688H27.3684V1.17188Z",
    fill: "#FFD422"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5247 1.17188H13.2539V9.14688H17.5247V1.17188Z",
    fill: "#FFD422"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5215 9.14648H9.14648V70.8543H18.5215V9.14648Z",
    fill: "#006DF0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M31.627 28.502H28.502V51.4973H31.627V28.502Z",
    fill: "#FF9811"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29688 32.9414H1.17188V37.2122H4.29688V32.9414Z",
    fill: "#FFD422"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29688 23.0977H1.17188V27.3684H4.29688V23.0977Z",
    fill: "#FFD422"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29688 13.2539H1.17188V17.5247H4.29688V13.2539Z",
    fill: "#FFD422"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29688 62.4727H1.17188V66.7434H4.29688V62.4727Z",
    fill: "#FFD422"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29688 42.7852H1.17188V47.0559H4.29688V42.7852Z",
    fill: "#FFD422"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29688 52.6289H1.17188V56.8997H4.29688V52.6289Z",
    fill: "#FFD422"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9746 32.9414H70.8496V37.2122H73.9746V32.9414Z",
    fill: "#FFD422"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9746 23.0977H70.8496V27.3684H73.9746V23.0977Z",
    fill: "#FFD422"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9746 13.2539H70.8496V17.5247H73.9746V13.2539Z",
    fill: "#FFD422"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9746 62.4727H70.8496V66.7434H73.9746V62.4727Z",
    fill: "#FFD422"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9746 42.7852H70.8496V47.0559H73.9746V42.7852Z",
    fill: "#FFD422"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9746 52.6289H70.8496V56.8997H73.9746V52.6289Z",
    fill: "#FFD422"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5938 22.1367H60.4688V27.3711H63.5938V22.1367Z",
    fill: "#C70024"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5938 30.9375H60.4688V36.1719H63.5938V30.9375Z",
    fill: "#C70024"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7695 63.4375H63.4258V65.7812H65.7695V63.4375Z",
    fill: "#1D1D1F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8633 63.4375H59.5195V65.7812H61.8633V63.4375Z",
    fill: "#1D1D1F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0508 63.4375H51.707V65.7812H54.0508V63.4375Z",
    fill: "#1D1D1F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M57.957 63.4375H55.6133V65.7812H57.957V63.4375Z",
    fill: "#1D1D1F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7695 59.4023H63.4258V61.7461H65.7695V59.4023Z",
    fill: "#1D1D1F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8633 59.4023H59.5195V61.7461H61.8633V59.4023Z",
    fill: "#1D1D1F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0508 59.4023H51.707V61.7461H54.0508V59.4023Z",
    fill: "#1D1D1F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M57.957 59.4023H55.6133V61.7461H57.957V59.4023Z",
    fill: "#1D1D1F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9688 31.25H35.625V33.5938H37.9688V31.25Z",
    fill: "#1D1D1F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M41.875 31.25H39.5312V33.5938H41.875V31.25Z",
    fill: "#1D1D1F"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0625 31.25H31.7188V33.5938H34.0625V31.25Z",
    fill: "#1D1D1F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M80 18.698V12.0833H72.025V7.975H67.9167V0H61.302V7.975H58.073V0H51.4583V7.975H48.2292V0H41.6145V7.975H38.3853V0H31.7708V7.98266L28.5416 7.98156V0H21.927V7.97953L18.6978 7.97844V0H12.0833V7.97625L7.975 7.975V12.0833H0V18.698H7.975V21.927H0V28.5417H7.975V31.7708H0V38.3855H7.975V41.6145H0V48.2292H7.975V51.4583H0V58.073H7.975V61.302H0V67.9167H7.975V72.0172L12.0833 72.0177V80H18.6978V72.0184L21.927 72.0188V80H28.5416V72.0197L31.7708 72.02V80H38.3853V72.0209L41.6145 72.0213V80H48.2292V72.022L51.4583 72.0223V80H58.073V72.0233L61.302 72.0236V80H67.9167V72.0245L72.025 72.025V67.9167H80V61.302H72.025V60.8984L69.6812 60.8906V69.6812H10.3172V10.317H69.6812V58.5547L72.025 58.5625V58.073H80V51.4583H72.025V48.2292H80V41.6145H72.025V38.3855H80V31.7708H72.025V28.5417H80V21.927H72.025V18.698C72.025 18.698 80 18.698 80 18.698ZM72.0256 14.427H77.6562V16.3542H72.0256V14.427ZM63.6458 2.34375H65.573V7.97437H63.6458V2.34375ZM53.802 2.34375H55.7292V7.97437H53.802V2.34375ZM43.9583 2.34375H45.8855V7.97437H43.9583V2.34375ZM24.2708 2.34375H26.1978V7.97437H24.2708V2.34375ZM14.427 2.34375H16.3541V7.97437H14.427V2.34375ZM7.97437 16.3542H2.34375V14.427H7.97437V16.3542ZM7.97437 26.198H2.34375V24.2708H7.97437V26.198ZM7.97437 36.0417H2.34375V34.1145H7.97437V36.0417ZM7.97437 55.7292H2.34375V53.802H7.97437V55.7292ZM7.97437 65.573H2.34375V63.6458H7.97437V65.573ZM16.3542 77.6562H14.427V72.0256H16.3541L16.3542 77.6562ZM26.198 77.6562H24.2709V72.0256H26.198V77.6562ZM36.0417 77.6562H34.1147V72.0256H36.0417V77.6562ZM45.8855 77.6562H43.9583V72.0256H45.8855V77.6562ZM55.7292 77.6562H53.802V72.0256H55.7292V77.6562ZM65.573 77.6562H63.6458V72.0256H65.573V77.6562ZM72.0256 63.6458H77.6562V65.573H72.0256V63.6458ZM7.97437 45.8855H2.34375V43.9583H7.97437V45.8855ZM34.1145 2.34375H36.0416V7.97437H34.1145V2.34375ZM72.0256 53.802H77.6562V55.7292H72.0256V53.802ZM72.0256 43.9583H77.6562V45.8855H72.0256V43.9583ZM72.0256 34.1145H77.6562V36.0417H72.0256V34.1145ZM72.0256 24.2708H77.6562V26.198H72.0256V24.2708Z",
    fill: "#1D1D1F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4766 32.1094V29.7656H52.6699V27.3302H50.2344V24.5313L47.8906 24.5234V27.3302H45.7031V24.5313L43.3594 24.5234V27.3302H41.1719V24.5313L38.8281 24.5234V27.3302H36.6406V24.5313L34.2969 24.5234V27.3302H32.1094V24.5313L29.7656 24.5234V27.3302H27.3302V29.7656H24.5313L24.5234 32.1016L27.3302 32.107V34.2969H24.5313L24.5234 36.6328L27.3302 36.6383V38.8281H24.5313L24.5234 41.1641L27.3302 41.1695V43.3594H24.5313L24.5234 45.6953L27.3302 45.7008V47.8906H24.5313L24.5234 50.2266L27.3302 50.232V52.6699H29.7656V55.4688L32.1094 55.4766V52.6699H34.2969V55.4688L36.6406 55.4766V52.6699H38.8281V55.4688L41.1719 55.4766V52.6699H43.3594V55.4688L45.7031 55.4766V52.6699H47.8906V55.4688L50.2344 55.4766V52.6699H52.6699V50.2289L55.4766 50.2344V47.8906H52.6699V45.6977L55.4766 45.7031V43.3594H52.6699V41.1664L55.4766 41.1719V38.8281H52.6699V36.6352L55.4766 36.6406V34.2969H52.6699V32.1039L55.4766 32.1094ZM50.3261 50.3261H29.6739V29.6739H50.3261V50.3261Z",
    fill: "#1D1D1F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2305 40.6367H45.8867V47.1992H48.2305V40.6367Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2305 32.8242H45.8867V35.168H48.2305V32.8242Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2305 36.7305H45.8867V39.0742H48.2305V36.7305Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9199 48.3631L37.223 48.3711V46.0273H31.9277L31.9199 48.3631Z",
    fill: "#1D1D1F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2559 14.2188H40.9121V16.5625H43.2559V14.2188Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3496 14.2188H37.0059V16.5625H39.3496V14.2188Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9902 14.2188H44.8184V16.5625H65.9902V14.2188Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9777 34.2969H18.1262V24.0625H12.1621L12.1543 26.4062H15.7824V36.6328L22.9777 36.6406V34.2969Z",
    fill: "#1D1D1F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9777 29.7734L21.798 29.7656V14.2188H12.1621L12.1543 16.5625H19.4543V32.1016L22.9777 32.1094V29.7734Z",
    fill: "#1D1D1F"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5684 38.8281V43.75H12.1621L12.1543 46.0938H15.9121V41.1719H22.9699L22.9777 38.8359L13.5684 38.8281Z",
    fill: "#1D1D1F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9777 43.3672L16.7199 43.3594V53.5938H12.1621L12.1543 55.9297L19.0637 55.9375V45.7031H22.9699L22.9777 43.3672Z",
    fill: "#1D1D1F"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1621 63.4375V65.7812H22.1621V50.2344H22.9695V47.8906H19.8184V63.4375H12.1621Z",
    fill: "#1D1D1F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8659 63.4375H29.0117V65.7812H37.8659V63.4375Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6777 63.4375H43.334V65.7812H45.6777V63.4375Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7715 63.4375H39.4277V65.7812H41.7715V63.4375Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M66.875 20.9629H59.2969V28.541H66.875V20.9629ZM64.5312 26.1973H61.6406V23.3066H64.5312V26.1973Z",
    fill: "#1D1D1F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M66.875 29.7656H59.2969V37.3438H66.875V29.7656ZM64.5312 35H61.6406V32.1094H64.5312V35Z",
    fill: "#1D1D1F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7812 43.4494L63.4375 43.4414V53.2931L65.7812 53.3009V43.4494Z",
    fill: "#1D1D1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroprocessador);
export default __webpack_public_path__ + "static/media/microprocessador.a29edd5eb1355da2b806d682e2b8bfbd.svg";
export { ForwardRef as ReactComponent };